<template>
  <div>
    <nav-bar></nav-bar>
    <el-input placeholder="请输入关键词(查看搜索技巧，学习更快找到你想要的内容)" v-model="inputKeyword"></el-input>
    <div class="searchLists">
      <el-tabs v-model="activeTab">
          <el-tab-pane v-for="tab in tabs" :key="tab.name" :label="tab.label" :name="tab.name">
            <el-row v-for="(item, index) in tab.data" :key="index">
              <a :href="generateSearchUrl(item, inputKeyword)" target="_blank" :title="item.name">{{ item.name }}</a>
            </el-row>
          </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/common/navbar/NavBar";
import searchData from "@/assets/yaml/search.yaml";
import searchDataTv from "@/assets/yaml/searchTv.yaml";
import searchMusic from "@/assets/yaml/searchMusic.yaml";
import searchImage from "@/assets/yaml/searchImage.yaml";
import searchDownload from "@/assets/yaml/searchDownload.yaml";
import searchApp from "@/assets/yaml/searchApp.yaml";
import searchTranslate from "@/assets/yaml/searchTranslate.yaml";
import searchSocial from "@/assets/yaml/searchSocial.yaml";
import searchShop from "@/assets/yaml/searchShop.yaml";
import searchScholar from "@/assets/yaml/searchScholar.yaml";
import searchBook from "@/assets/yaml/searchBook.yaml";

export default {
  props: ['keyword'],
  name: "Search",
  components: {
    NavBar,
  },
  data() {
    return {
      inputKeyword: '',
      activeTab: "searchEngines",
      tabs: [
        {
          // label: '搜索',
          label: this.$t('search.searchEngines'),
          name: 'searchEngines',
          data: searchData
        },
        {
          label: this.$t('search.image'),
          name: 'image',
          data: searchImage
        },
        {
          label: this.$t('search.translate'),
          name: 'translate',
          data: searchTranslate
        },
        {
          label: this.$t('search.social'),
          name: 'social',
          data: searchSocial
        },
        {
          label: this.$t('search.moviesAndTV'),
          name: 'moviesAndTV',
          data: searchDataTv
        },
        {
          label: this.$t('search.music'),
          name: 'music',
          data: searchMusic
        },
        
        {
          label: this.$t('search.download'),
          name: 'download',
          data: searchDownload
        },
        {
          label: this.$t('search.app'),
          name: 'app',
          data: searchApp
        },
        {
          label: this.$t('search.shop'),
          name: 'shop',
          data: searchShop
        },
        {
          label: this.$t('search.book'),
          name: 'book',
          data: searchBook
        },
        {
          label: this.$t('search.scholar'),
          name: 'scholar',
          data: searchScholar
        }
      ]
    };
  },
  created() {
    // 检查是否有路由参数
    if (this.keyword) {
      this.inputKeyword = this.keyword;
    } else {
      this.inputKeyword = ''; // 如果没有参数，则将输入框的值设置为空
    }
  },
  watch: {
    inputKeyword(newKeyword) {
      if (newKeyword !== '') {
        this.updateRoute(newKeyword);
      } else {
        this.$router.push({ name: 'searchWithoutKeyword' });
      }
    }
  },
  methods: {
    generateSearchUrl(item, keyword) {
      return item.url + (keyword ? keyword : this.inputKeyword) + (item.suffix ? item.suffix : '');
    },
    updateRoute(newKeyword) {
      if (this.$route.params.keyword !== newKeyword) {
        this.$router.push({ name: 'searchWithKeyword', params: { keyword: newKeyword } });
      }
    }
  }
};
</script>
<style scoped>
.el-tab-pane {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.el-tab-pane .el-row{
  width: 14%;
  margin: 10px 20px 10px 0;
  padding: 0 10px;
  height: 2.2rem;
  line-height: 2.2rem;
}
.el-tab-pane .el-row a {
  display: inline-block;
  text-align: center;
  width: 100%;
  background: #333;
  border-radius: 22px;
  text-decoration: none;
  color: #fff;
  white-space:nowrap;
  overflow: hidden;
}

@media screen and (max-width: 760px) {
  .el-tab-pane .el-row {
    width: 40%;
  }

}

@media screen and (max-width: 960px) {
  /* 导航条滚动显示 */
  /deep/ .el-tabs__nav-scroll {
    overflow-x: auto !important;
    white-space: nowrap !important; /* 使标签在一行内显示 */
  }
}

@media (min-width: 761px) and (max-width: 960px) {
  .el-tab-pane .el-row {
    width: 20%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/search/Search.vue